var murmur = 1
var oldmurmur = 1;
var lang = 'en';
// if(localStorage.getItem('lang')){
//     lang = localStorage.getItem('lang');
// } else {
//     var _languages = ['en','ja','de','fr','es','pt','ko'];
//     for ( var i = 0; i < _languages.length; i++){
//       if (_languages[i] === navigator.language) {
//         lang = navigator.language;
//         localStorage.setItem('lang',lang);
//         sessionStorage.setItem('lang',lang);
//         break;
//       }else{
//         lang = 'en';
//         localStorage.setItem('lang',lang);
//         sessionStorage.setItem('lang',lang);
//       }
//     }
// };
try {
  var fpPromise = FingerprintJS.load()
  fpPromise
    .then(fp => fp.get())
    .then(result => {
      murmur = result.visitorId
      oldmurmur = result.visitorId
      sessionStorage.setItem('murmur', murmur);
      cookie.setcookie('murmur', murmur);
    })
} catch (e) {
  console.log('fingerjs is not defined')
};
function cLass(p) {
    return document.getElementsByClassName(p);
};
function iD(p) {
    return document.getElementById(p);
};
function tAg(p) {
    return document.getElementsByTagName(p);
};
function seLect(p) {
    return document.querySelector(p);
};
function seLectorAll(p) {
    return document.querySelectorAll(p);
};
var user_plan = null;
//成功
function _success(text) {
    showText('success', text, '/images/toast/icon_su.svg');
};
//失败
function _error(text) {
    showText('error', text, '/images/toast/icon_dialogue.svg');
};
//警告
function _warning(text) {
    showText('warning', text, '/images/toast/icon-warning.svg');
};
function showText(type, text, icon, top) {
    var top_text;
    top ? top_text = top : top_text = capitalizeFirstLetter(type);
    var newDiv = document.createElement("div");
    newDiv.classList = 'toast ' + type;
    newDiv.setAttribute('id', 'toast')
    newDiv.innerHTML = '<img src="' + icon + '" alt="' + type + '">' +
        '<div class="right">' +
        '<div><p>' + top_text + '</p><p>' + text + '</p></div>' +
        '<i class="close" onclick="closeText(this)"></i>' +
        '</div>';
    document.body.appendChild(newDiv);
    adjustTextPositions();
    setTimeout(function () {
        iD('toast').style.opacity = 0;
    }, 2500);
    setTimeout(function () {
        try {
            iD('toast').remove();
            adjustTextPositions();
        } catch (e) { }
    }, 2800);
};
function closeText(closeButton) {
    var _taget = closeButton;
    var toast = _taget.parentNode.parentNode;
    toast.style.opacity = 0;
    setTimeout(function () {
        try {
            toast.remove();
            adjustTextPositions();
        } catch (e) { }
    }, 300);
};
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

function adjustTextPositions() {
    var topOffset = 85; // 初始偏移量
    for (let i = 0; i < cLass('toast').length; i++) {
        (function (i) {
            cLass('toast')[i].style.top = topOffset + 'px';
            topOffset += cLass('toast')[i].offsetHeight + 10;
        })(i)
    }
};
function getcookie(name) {
    var currentDomain = window.location.hostname;
    var cookies = document.cookie.split(';');
    var cookieValue = null;
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];

        if (cookie.substring(0, name.length + 1) == (name + '=')) {
            var cookieContent = cookie.substring(name.length + 1);
            var domainMatch = /domain=([^;]*)/.exec(cookie);
            var cookieDomain = domainMatch ? domainMatch[1] : currentDomain;
            if (cookieDomain === currentDomain || cookieDomain === '.' + currentDomain) {
                try {
                    cookieValue = decodeURIComponent(cookieContent);
                } catch (e) {
                    cookieValue = cookieContent;
                }

                break;
            }
        }
    }
    return cookieValue;
}
var _eid = cookie.getcookie('murmur');
function getFetch(url, opt, token, method) {
    var headers = {};
    headers['Content-Type'] = 'application/json';
    headers['basic-params'] = '';
    token ? headers['Access-Token'] = token : null;
    return fetch(url, {
        method: method,
        headers: headers,
        body: JSON.stringify(opt)
    })
        .then(response => {
            if (!response.ok) {
                return response.json().then(json => Promise.reject(json));
            }
            return response.json();
        })
        .catch(function (error) {
            return error
        });
};
function error_fn(id, that) {
    switch (id) {
        case 20001:
            _error(i18n[lang].error_20001);
            if (location.origin.indexOf('account.') > -1) {
                setTimeout(function () {
                    location.href = `${lang_path}/account/login/`;
                }, 1000);
            }
            return false;
            break;
        case 20002:
            _error(i18n[lang].error_20002);
            if (location.origin.indexOf('account.') > -1) {
                setTimeout(function () {
                    location.href = `${lang_path}/account/login/`;
                }, 1000);
            }
            return false;
            break;
        case 20003:
            _error(i18n[lang].error_20003);
            if (location.origin.indexOf('account.') > -1) {
                setTimeout(function () {
                    location.href = `${lang_path}/account/login/`;
                }, 1000);
            }
            return false;
            break;
        case 20004:
            _error(i18n[lang].error_20004);
            return false;
            break;
        case 20005:
            cookie.setcookie("user", "", -1)
            if (location.origin.indexOf('account.') > -1) {
                location.href = `${lang_path}/account/login/`;
            }
            return false;
            break;
        case 20006:
            _error(i18n[lang].error_20006);
            return false;
            break;
        case 20007:
            _error(i18n[lang].error_20007);
            if (location.origin.indexOf('account.') > -1) {
                setTimeout(function () {
                    location.href = `${lang_path}/account/login/`;
                }, 1000);
            }
            return false;
            break;
        case 20008:
            _error(i18n[lang].error_20008);
            if (location.origin.indexOf('account.') > -1) {
                setTimeout(function () {
                    location.href = `${lang_path}/account/login/`;
                }, 1000);
            }
            return false;
            break;
        case 20009:
            _error(i18n[lang].error_20009);
            if (location.origin.indexOf('account.') > -1) {
                setTimeout(function () {
                    location.href = `${lang_path}/account/login/`;
                }, 1000);
            }
            return false;
            break;
    }
    return true;
}
// 地址栏判断操作
if (getQueryVariable('operation')) {
    sessionStorage.setItem('operation', 'close');
}
if (getQueryVariable('3rdGoogle') == 'error') {
    _error(i18n[lang].error_22298);
}
// 请求接口地址
let post_url;
let google_client_id;
let websiet;
let domain = ".heyreal.ai";
if (location.hostname == 'heyreal.ai') {
    post_url = "https://api.heyreal.ai/api/";
    google_client_id = "331599668874-c0ic2hp0rqggpi0gljurhven1otrjce9.apps.googleusercontent.com";
    websiet = "https://heyreal.ai/";
} else if (location.hostname == 'sandbox.heyreal.ai') {
    post_url = "https://sandboxapi67.heyreal.ai/api/";
    google_client_id = "168504817543-lpb9es6r12llndtvi6o9kkejr3vcmt7a.apps.googleusercontent.com";
    websiet = "https://sandbox.heyreal.ai/"
} else if (location.hostname == 'pre.heyreal.ai') {
    post_url = "https://preapi.heyreal.ai/api/";
    google_client_id = "168504817543-lpb9es6r12llndtvi6o9kkejr3vcmt7a.apps.googleusercontent.com";
    websiet = "https://pre.heyreal.ai/"
} else {
    post_url = "https://sandboxapi67.heyreal.ai/api/";
    google_client_id = "168504817543-lpb9es6r12llndtvi6o9kkejr3vcmt7a.apps.googleusercontent.com";
    websiet = "https://sandbox.heyreal.ai/"
};
//记住页面来源
if (getQueryVariable('source')) {
    localStorage.setItem('source', getQueryVariable('source'));
} else {
    if (!localStorage.getItem('source')) {
        localStorage.setItem('source', websiet);
    }
}
murmur = sessionStorage.getItem('murmur');
// google登录接口函数
function google_login(callback, registerCallback, mergeCallback) {
    getFetch(post_url + 'account/google/login', {
        e_id: sessionStorage.getItem('murmur'),
        id_token: JSON.parse(cookie.getcookie('user_google')).google_id_token
    }, null, 'POST')
        .then(data => {
            error_fn(data.code);
            cookie.deletecookie('google_key');
            switch (data.code) {
                case 0:
                    var time = setInterval(function () {
                        if (murmur != 1) {
                            clearInterval(time);
                            cookie.setcookie('user', JSON.stringify({ 'e_id': murmur, 't_id': data.data.t_id, 'token': data.data.token }), 90);
                            if (callback) {
                                callback();
                                return false;
                            }
                            if (sessionStorage.getItem('operation') == 'close') {
                                location.href = `${lang_path}/successful-login`
                            } else {
                                //location.href=localStorage.getItem('source');
                            }
                            login_state.AccessToken = data.data.token;
                            login_handle()
                        }
                    }, 1)
                    break;
                case 21601:
                    _error(i18n[lang].error_21601);
                    break;
                case 21602:
                    _error(i18n[lang].error_21602);
                    break;
                case 21603:
                    _error(i18n[lang].error_21603);
                    break;
                case 21604:
                    _error(i18n[lang].error_21604);
                    break;
                case 21605:
                    // 不提示，自动去创建账号并登录
                    if (registerCallback) {
                        registerCallback()
                        return false;
                    }
                    third_party_registered_fn(0);
                    break;
                case 21606:
                    _error(i18n[lang].error_21606);
                    break;
                case 21607:
                    // 不提示，不去注册，跳转是否合并邮箱页面
                    if (mergeCallback) {
                        mergeCallback()
                        return false;
                    }
                    // location.href="/3rd-login-merge-account";
                    // 帮忙绑定账号
                    third_party_registered_fn(21607);
                    break;
                case 21608:
                    //自动帮忙注册一个账号
                    if (registerCallback) {
                        registerCallback()
                        return false;
                    }
                    third_party_registered_fn(21607);
                    break;
                case 21609:
                    // 不提示，不去注册，跳转是否合并邮箱页面
                    if (mergeCallback) {
                        mergeCallback()
                        return false;
                    }
                    // 帮忙绑定账号
                    third_party_registered_fn(21607);
                    break;
                case 21610:
                    // 不提示，自动去注册一个3方账号并登录；创建成功后选择绑定，自动填充获得的Google 邮箱，同21608
                    if (registerCallback && mergeCallback) {
                        registerCallback()
                        mergeCallback()
                        return false;
                    }
                    third_party_registered_fn(0);
                    // 帮忙绑定账号
                    third_party_registered_fn(21607);
                    break;
                case 21611:
                    _error(i18n[lang].error_21611);
                    break;
                case 21613:
                    _error(i18n[lang].error_21613);
                    break;
                case 21828:
                    showText('error', i18n[lang].error_21828, '/images/toast/icon_dialogue.svg', i18n[lang].error_21829);
                    try {
                        iD('loginButton').innerHTML = '';
                        iD('loginButton').innerHTML += `<i class="ivu-icon iconfont icon-user userIcon"></i><span class="signIn">${i18n[lang].log_in}</span>`;
                        iD('loginMask').classList.add('ishideme').remove('isshowme');
                    } catch (e) { };
                    cookie.deletecookie('user_google');
                    break;
                case 500:
                    _error(i18n[lang].isnetwork);
                    break;
            }
        })
        .catch(function (error) {
            overtime(21699);
        });
};
// google账号注册
function third_party_registered_fn(operation, callback, callbackGoogle) {
    if (!isnetwork()) { return false; };
    let data = {
        e_id: sessionStorage.getItem('murmur'),
        id_token: JSON.parse(cookie.getcookie('user_google')).google_id_token
    };
    switch (operation) {
        case 0:
            data = {
                e_id: sessionStorage.getItem('murmur'),
                id_token: JSON.parse(cookie.getcookie('user_google')).google_id_token
            }
            break;
        case 21607:
            data = {
                e_id: sessionStorage.getItem('murmur'),
                id_token: JSON.parse(cookie.getcookie('user_google')).google_id_token,
                connect: 1
            }
            break;
        case 21608:
            break;
        case 21609:
            break;
        case 21610:
            break;
    }
    getFetch(post_url + 'account/google/register', data, null, 'POST')
        .then(data => {
            error_fn(data.code);
            switch (data.code) {
                case 0:
                    cookie.setcookie('user', JSON.stringify({ 'e_id': sessionStorage.getItem('murmur'), 't_id': data.data.t_id, 'token': data.data.token }), 90);
                    if (operation == 21607) {
                        if (callback) {
                            callback();
                            return false;
                        }
                    } else {
                        if (callback) {
                            callback();
                            return false;
                        }
                    }

                    location.href = localStorage.getItem('source');
                    break;
                case 21613:
                    _error(i18n[lang].error_21613);
                    break;
                case 21801:
                    _error(i18n[lang].error_21801);
                    break;
                case 21802:
                    _error(i18n[lang].error_21802);
                    break;
                case 21803:
                    _error(i18n[lang].error_21803);
                    break;
                case 21804:
                    _error(i18n[lang].error_21804);
                    break;
                case 21805:
                    if (callbackGoogle) {
                        callbackGoogle()
                        return false;
                    }
                    google_login()
                    break;
                // 不提示，重新三方登录到新的账号上
                case 21806:
                    _error(i18n[lang].error_21806);
                    break;
                case 21807:
                    _error(i18n[lang].error_21807);
                    break;
                case 21808:
                    _error(i18n[lang].error_21808);
                    break;
                case 21809:
                    _error(i18n[lang].error_21809);
                    break;
                case 21810:
                    _error(i18n[lang].error_21810);
                    break;
                case 21811:
                    _error(i18n[lang].error_21811);
                    break;
                case 21812:
                    _error(i18n[lang].error_21812);
                    break;
                case 21813:
                    _error(i18n[lang].error_21813);
                    break;
                case 21814:
                    _error(i18n[lang].error_21814);
                    break;
                case 21815:
                    _error(i18n[lang].error_21815);
                    break;
                case 21816:
                    _error(i18n[lang].error_21816);
                    break;
                case 21817:
                    _error(i18n[lang].error_21817);
                    break;
                case 21818:
                    _error(i18n[lang].error_21818);
                    break;
                case 21819:
                    _error(i18n[lang].error_21819);
                    break;
                case 21820:
                    _error(i18n[lang].error_21820);
                    break;
                case 21821:
                    _error(i18n[lang].error_21821);
                    break;
                case 21822:
                    _error(i18n[lang].error_21822);
                    break;
                case 21823:
                    _error(i18n[lang].error_21823);
                    break;
                case 21824:
                    _error(i18n[lang].error_21824);
                    break;
                case 21825:
                    _error(i18n[lang].error_21825);
                    break;
                case 21826:
                    _error(i18n[lang].error_21826);
                    break;
                case 21827:
                    _error(i18n[lang].error_21827);
                    break;
                case 21828:
                    showText('error', i18n[lang].error_21828, '/images/toast/icon_dialogue.svg', i18n[lang].error_21829)
                    break;
            }
        })
        .catch(function (error) {
            overtime(21899);
        });
};
// checkLoginStatus(); // 每次点击按钮时先检查登录状态
if (!cookie.getcookie('userInfoData') && !cookie.getcookie('user')) {
    if (location.hostname == 'localhost-www.heyreal.ai' || location.hostname == 'sandbox.heyreal.ai') {
        seLect('body').innerHTML += `
            <div id="g_id_onload"
            data-client_id="435797899393-2tsncp94q06tk9r3q9mslrp83rco4q21.apps.googleusercontent.com"
            data-context="signin"
            data-callback="haedcallback"
            data-auto_select="true"
            data-close_on_tap_outside="false"
            data-itp_support="true">
            </div>
        `;
        function haedcallback(response) {
            cookie.setcookie('user_google', JSON.stringify({ 'google_id_token': response.credential }), 90);
            cookie.setcookie('google_id_token', JSON.stringify({ 'google_id_token': response.credential }), 90);
            google_login();
        };
    } else {
        seLect('body').innerHTML += `
            <div id="g_id_onload"
            data-client_id="461772325941-l9lds99poqu4d2qs7e85c55pi6kd3n55.apps.googleusercontent.com"
            data-context="signin"
            data-callback="real_haedcallback"
            data-auto_select="true"
            data-close_on_tap_outside="false"
            data-itp_support="true">
            </div>
        `;
        function real_haedcallback(response) {
            cookie.setcookie('user_google', JSON.stringify({ 'google_id_token': response.credential }), 90);
            cookie.setcookie('google_id_token', JSON.stringify({ 'google_id_token': response.credential }), 90);
            google_login();
        };
    };
} else {
}
window.addEventListener('online', function () {
    if (!cookie.getcookie('userInfoData') && !cookie.getcookie('user')) {
        if (location.hostname == 'localhost-www.heyreal.ai' || location.hostname == 'sandbox.heyreal.ai') {
            seLect('body').innerHTML += `
                <div id="g_id_onload"
                data-client_id="435797899393-2tsncp94q06tk9r3q9mslrp83rco4q21.apps.googleusercontent.com"
                data-context="signin"
                data-callback="haedcallback"
                data-auto_select="true"
                data-close_on_tap_outside="false"
                data-itp_support="true">
                </div>
            `;
            function haedcallback(response) {
                cookie.setcookie('user_google', JSON.stringify({ 'google_id_token': response.credential }), 90);
                cookie.setcookie('google_id_token', JSON.stringify({ 'google_id_token': response.credential }), 90);
                google_login();
            };
        } else {
            seLect('body').innerHTML += `
                <div id="g_id_onload"
                data-client_id="461772325941-l9lds99poqu4d2qs7e85c55pi6kd3n55.apps.googleusercontent.com"
                data-context="signin"
                data-callback="real_haedcallback"
                data-auto_select="true"
                data-close_on_tap_outside="false"
                data-itp_support="true">
                </div>
            `;
            function real_haedcallback(response) {
                cookie.setcookie('user_google', JSON.stringify({ 'google_id_token': response.credential }), 90);
                cookie.setcookie('google_id_token', JSON.stringify({ 'google_id_token': response.credential }), 90);
                google_login();
            };
        };
    } else {
    }
});
// 修改函数的进位
function autoNumberTransform(num) {
    var like_num = num;
    if (like_num < 1000) {
        like_num = like_num;
    }
    else if (like_num >= 1000 && like_num < 1000000) {
        like_num = (like_num / 1000).toFixed(1) + 'K';
    }
    else if (like_num >= 1000000 && like_num < 1000000000) {
        like_num = (like_num / 1000000).toFixed(1) + 'M';
    }
    else if (like_num >= 1000000000) {
        like_num = (like_num / 1000000).toFixed(1) + 'B';
    }
    return like_num;
};
// 判断是否为google登陆
if (cookie.getcookie('google_key')) {
    // $.ajaxSettings.async = false;
    oauthInfo();
    // $.ajaxSettings.async = true;
    function oauthInfo() {
        getFetch(post_url + 'account/google/oauth1/info', {
            e_id: sessionStorage.getItem('murmur'),
            key: cookie.getcookie('google_key')
        }, null, 'POST')
            .then(data => {
                error_fn(data.code);
                cookie.setcookie('google_key', "", -1);
                switch (data.code) {
                    case 0:
                        cookie.setcookie('user_google', JSON.stringify({ 'google_id_token': data.data.id_token }), 90);
                        cookie.setcookie('google_id_token', JSON.stringify({ 'google_id_token': data.data.id_token }), 90);
                        google_login()
                        break;
                    case 26701:
                        _error(i18n[lang].error_26701);
                        break;
                    case 26702:
                        _error(i18n[lang].error_26702);
                        break;
                    case 26703:
                        _error(i18n[lang].error_26703);
                        break;
                    case 26704:
                        _error(i18n[lang].error_26704);
                        break;
                    case 26705:
                        oauthInfo();
                        break;
                }
            })
            .catch(function (error) {
                overtime(26799);
            });
    }
};
//登陆处理相关信息
function login_handle(token) {
    _token = token;
    _e_id = _eid;
    if (cookie.getcookie('user_google')) { cookie.deletecookie('user_google'); }
    getAjax(_url.getUserInfo, { e_id: _e_id }).then(response => {
        if (response.code == 8001) {
            handleLogout();
        } else if (response.code != 200) {
            return;
        };
        if (response.data.avatar_url) {
            // if($('.loginButton .avatarUser').length > 0) {
            try { cLass('avatarUser').remove(); } catch (e) { }
            // if($('.loginButton >img').length){
            // $('.loginButton img').attr('avatar_url',response.data.avatar_url)
            // }else{
            const image = new Image();
            image.src = response.data.avatar_url
            image.onload = function () {
            };
            var newDImg = document.createElement('img');
            newDImg.classList.add('login_user_img');
            newDImg.style = 'width: 40px; height: 40px; border-radius: 50%; object-fit: contain';
            newDImg.src = response.data.avatar_url;
            newDImg.avatar_url = response.data.avatar_url;
            newDImg.alt = 'Login';
            try {
                iD('loginButton').innerHTML = '';
                iD('loginButton').appendChild(newDImg);
            } catch (e) { };
            // iD('loginButton').innerHTML=`<img class="login_img" src="/images/index/icon-login.svg" avatar_url="${response.data.avatar_url}" style="width: 40px; height: 40px; border-radius: 50%; object-fit: contain;" alt="Login"/>`;
            // }
            try { iD('login_img').setAttribute('src', response.data.avatar_url); } catch (e) { };
            // } else {
            //     $('.loginButton img').attr({'src': response.data.avatar_url})
            // }
        } else {
            try {
                iD('loginButton').innerHTML = '';
                iD('loginButton').innerHTML += `<img src="/images/index/icon-login.svg" avatar_url="/images/index/icon-login.svg" style="width: 40px; height: 40px; border-radius: 50%; object-fit: contain;" alt="Login"/>`;
            } catch (e) { };
        };
        if (response.data.red_dot && response.data.red_dot == 1) {
            $('.BonusMenu .icon-menu_bonus').addClass('active')
            $('.navigation .leftNavigation .menuIcon').addClass('active');
        };
        response.data.nickname ? iD('login_name').innerHTML = response.data.nickname : null;
        if(response.data.title && response.data.title_icon && response.data.title_id){
            iD('login_name').insertAdjacentHTML('afterend', `<img src="${response.data.title_icon}" title="${response.data.title}" class="personal_metal" alt="metal" id="personal_metal" attr-id="${response.data.title_id}" width="24" height="24">`);
            iD('personal_metal').onclick = function (e){
                e.stopPropagation();
                e.preventDefault();
                if(location.pathname!=`${lang_path}/bonus/`){
                    window.location.href = `${lang_path}/bonus/?#metal_zoon`+response.data.title_id;
                }
            }
        };
        response.data.email ? iD('login_email').innerHTML = response.data.email : null;
        response.data.nickname ? iD('nick_name').value = response.data.nickname : null;
        response.data.introduction ? iD('edit_personality').value = response.data.introduction : null;
        response.data.planname ? iD('user_plan_title').innerHTML = response.data.planname : null;
        if (response.data.planname == 'Free' && response.data.remaining_num) {
            iD('message').innerHTML = 'Bonus Messages:';
            response.data.remaining_num ? iD('user_plan_num').innerHTML = response.data.remaining_num : iD('user_plan_num').innerHTML = '0';
        } else if (response.data.planname != 'Free' && response.data.message_num && response.data.usage) {
            iD('message').innerHTML = 'Subscription Messages:';
            if (response.data.planname.indexOf('Deluxe') > -1) {
                iD('user_plan_num').innerHTML = 'Unlimited';
            } else {
                response.data.remaining_num ? iD('user_plan_num').innerHTML = response.data.message_num - response.data.usage : iD('user_plan_num').innerHTML = '0';
            }
        }

        //用户性别
        if (response.data.gender) {
            if (response.data.gender == 0) {
                seLect('label[for="_male"]').click('');
            } else if (response.data.gender == 1) {
                seLect('label[for="_female"]').click('');
            } else if (response.data.gender == 2) {
                seLect('label[for="non_binary"]').click('');
            }
        };
        if (response.data.private_collection == 1) {
            seLect('label[for="favorites"]').click('');
        } else if (response.data.private_collection == 0) {

        };
        if (response.data.private_likes == 1) {
            seLect('label[for="likes"]').click('');
        } else if (response.data.private_likes == 0) {

        };
        // if (response.data.categoryJson) {
        //     var _category = 0;
        //     seLectedTags = [];
        //     for (var udd = 0; udd < response.data.categoryJson.length; udd++) {
        //         for (var uii = 0; seLectorAll('.tagsId div').length; uii++) {
        //             if (Number(seLectorAll('.tagsId div')[uii].getAttribute('id')) == response.data.categoryJson[udd].id) {
        //                 seLectorAll('.tagsId div')[uii].classList.add('active');
        //                 _category++;
        //                 seLectedTags.push(response.data.categoryJson[udd].id);
        //                 break;
        //             }
        //         }
        //     };
        //     seLectorAll('.profile_mask .tags_num').innerHTML = _category;
        // };
        if (response.data.social_links) {
            for ( var udd in response.data.social_links) {
                response.data.social_links[udd]?iD(udd).checked = true:iD(udd).checked = false;
                response.data.social_links[udd]?iD('input_'+udd).value=response.data.social_links[udd]:null;
                response.data.social_links[udd]?iD('input_'+udd).classList.add('allowed'):null;
                response.data.social_links[udd]?iD('input_'+udd).classList.add('active'):null;
            }
        };
        var userInfoData = response.data;
        userInfoData.eid = _e_id;
        response.data ? cookie.setcookie('userInfoData', JSON.stringify(userInfoData), 90) : null;
        // 绑定遮罩区域点击事件（用于关闭弹窗）
        iD('loginMask').addEventListener('click', function (e) {
            this.classList.remove('isshowme');
            this.classList.add('ishideme');
        });
        // 绑定登出按钮事件
        iD('logout').addEventListener('click', handleLogout);
        iD('info_profile').addEventListener('click', handleProfile);
        iD('profile_edit').addEventListener('click', handleInfo);
        try { iD('loginButton').removeEventListener('click', login_toggle); } catch (e) { };
        try { iD('profileMetalBtn').innerHTML='Unlock My Achievement' } catch (e) { };
        autoSetupData(userInfoData);
        // 首页签到任务奖励弹窗
        // if (userInfoData.sign_in == '0' && userInfoData.new_user == 0) {
        //     $('.checkInPopUpWindowMask').length && $('.checkInPopUpWindowMask').show();
        // }
        //  impact注册上报
        if (userInfoData.google_report == 1) {
            updateImpactRegister();
        }
        if (userInfoData.sign_in == '0') {
            $('.missionContent').length && $('.missionContent.web .right .signIn').text('Earn').addClass('allow').removeClass('no');
            $('.missionContent').length && $('.missionContent.web .right .signIn.allow').click(function () {
                getAjax(_url.signIn, {}).then(res => {
                    $('.checkInPopUpWindowMask').hide();
                    if (res.code == 200) {
                        synchronizedPoints(res.data.num, '.signIn', 'Cooling Down')
                        $('.bonusTime') && $('.bonusTime').text(userInfoData.remainder);
                    } else if(res.code == 204){
                        return false;
                    } else {
                        error('Check-in failed. Please try again later.')
                    }
                })
            })
            $('.missionContent').length && $('.missionContent.phone .signIn').text('Earn').addClass('allow').removeClass('no');
            $('.missionContent').length && $('.missionContent.phone .signIn.allow').click(function () {
                getAjax(_url.signIn, {}).then(res => {
                    $('.checkInPopUpWindowMask').hide();
                    if (res.code == 200) {
                        synchronizedPoints(res.data.num, '.signIn', 'Cooling Down')
                        $('.bonusTime') && $('.bonusTime').text(userInfoData.remainder);
                    } else if(res.code == 204){
                        return false;
                    } else {
                        error('Check-in failed. Please try again later.')
                    }
                })
            })
        } else {
            $('.bonusTime') && $('.bonusTime').text(userInfoData.remainder);
            $('.checkInPopUpWindowMask') && $('.checkInPopUpWindowMask').hide();
            $('.missionContent').length && $('.missionContent.web .right .signIn').text('Cooling Down').addClass('no').removeClass('allow');
            $('.missionContent').length && $('.missionContent.phone .signIn').text('Cooling Down').addClass('no').removeClass('allow');
        }
        $('.missionContent') && $('.missionContent .inviteNum').text(userInfoData.use_share_num);
        $('.checkInPopUpWindowMask .close').click(function () {
            $('.checkInPopUpWindowMask').hide();
        })
        $('.checkInPopUpWindowMask button').click(function () {
                getAjax(_url.signIn, {}).then(res => {
                    $('.checkInPopUpWindowMask').hide();
                    synchronizedPoints(res.data.num, '.signIn', 'Cooling Down');
                    if (res.code == 200) {
                        getAjax(_url.getRedDot, {
                        }).then(data => {
                            if (data.code == 200) {
                                if (data.data && data.data.red_dot != 1 ) {
                                    $('.BonusMenu .icon-menu_bonus').removeClass('active');
                                }
                                 if (data.data.message_red != 1 && data.data.red_dot != 1) {
                                    $('.navigation .leftNavigation .menuIcon').removeClass('active');
                                }
                            }
                        })
                        success('10 coins have been added to your account. Go check and redeem in the Bonus tag.')
                    } else if(res.code == 204){
                        return false;
                    }  else {
                        error('Check-in failed. Please try again later.')
                    }
                })
        });
        try{
            userInfoData.use_share_num == 5?$('.InviteContent').addClass('fit').addClass('mission_toggled'):null;
        }catch(e){};
        $('.bonusHeader .source').length && $('.bonusHeader .source').text(userInfoData.score || 0);
        $('.remain_source').length && $('.remain_source').text(userInfoData.score || 0);
        session_store.saveToSessionStorage('score', userInfoData.score);
        $('.bonusHeader .remaining_num').length && $('.bonusHeader .remaining_num').text(userInfoData.remaining_num || 0);
        $('.bonusHeader .item_card_num').length && $('.bonusHeader .item_card_num').text(userInfoData.item_card_num || 0);
        let recordsNum = parseInt(userInfoData.records_num);
        $('.missionContent') && $('.missionContent .recordNum').text(recordsNum >= 10 ? 10 : recordsNum);
        if (userInfoData.records_status == 1) {
            $('.missionContent') && $('.missionContent button.chat').text('Completed').removeClass('chat');
        }
        if (recordsNum >= 10) {
            $('.missionContent') && $('.missionContent button.chat').removeClass('no');
            $('.missionContent') && $('.missionContent button.chat').click(function () {
                getAjax(_url.bonusSendMessage, {}).then(res => {
                    if (res.code == 200) {
                        synchronizedPoints(res.data.num, 'button.chat', 'Completed');
                    }
                })
            })
        }
        switch (userInfoData.create_role_status) {
            case '0':
                $('.missionContent') && $('.missionContent .create').click(function () {
                    redirectToUrl(`${lang_path}/character/create/`);
                })
                break;
            case '1':
                $('.missionContent') && $('.missionContent .create').text('Earn');
                $('.missionContent') && $('.missionContent .create').addClass('earn');
                $('.missionContent') && $('.missionContent .create').click(function () {
                    if ($(this).hasClass('no')) {
                        return; // 如果包含 .no 类名，则退出，不执行后续逻辑
                    }
                    getAjax(_url.bonusCreateCharacter, {}).then(res => {
                        if (res.code == 200) {
                            synchronizedPoints(res.data.num, '.create', 'Completed')
                        } else {
                            error('Check-in failed. Please try again later.')
                        }
                    })
                })
                break;
            case '2':
                $('.missionContent') && $('.missionContent .create').text('Completed').addClass('no');
                $('.missionContent').length && $(`.missionContent .create`).parent().parent().addClass('mission_toggled');
                $('.missionContent').length && $(`.missionContent .create`).parent().parent().addClass('fit');
                break;
        }
        $('.missionContent') && $('.missionContent .code').text(userInfoData.invite_code).css('color', '#333');
        if (userInfoData.new_user === 0) {
            $('.missionContent') && $('.missionContent .exchange').text('Overdue').addClass('no');
            $('.missionContent') && $('.RedeemInvite').addClass('fit').addClass('mission_toggled');
        } else {
            if (userInfoData.redeem_invite == 1) {
                $('.missionContent') && $('.missionContent .exchange').text('Completed').addClass('no');
                return;
            }
            $('.missionContent') && $('.missionContent .exchange').click(function () {
                if (!$(this).siblings('input').val()) {
                    $(this).siblings('input').css('border', '1px solid #FF426F');
                    return;
                }
                if ($(this).hasClass('no')) {
                    return;
                }
                getAjax(_url.bonusInviteCode, { invite_code: $(this).siblings('input').val() }).then(res => {
                    if (res.code == 200) {
                        synchronizedPoints(res.data.num, '.exchange', 'Completed')
                    } else if (res.code == 2310) {
                        error('You can not use your own invite code, try with others. ');
                    } else if (res.code == 2309) {
                        error('Please enter the right code and try again.');
                    } else {
                        error('Check-in failed. Please try again later.');
                    }
                })
            })
        };
        $('.header_select_zoon')&&$('.header_select_zoon').addClass('beside');
        $('.language_toggle')&&$('.language_toggle').addClass('beside');
    });
};

//同步用户个人页 和 用户看他人的用户数据
function autoSetupData(userInfoData) {
    //plan 类型
    // scrollToTop(seLectorAll('.profile_mask .ivu-col-span-xxl-10'));
    if (userInfoData.avatar_url) {
        if (seLectorAll('.profile_mask .avatarBox .avatarList').length > 0) {
            seLectorAll('.profile_mask .avatarBox .avatarList')[0].innerHTML = `<img src="${userInfoData.avatar_url}" data-src="${userInfoData.avatar_url}"/>`
        } else {
            seLectorAll('.profile_mask .avatarBox')[0].innerHTML += `<div class="avatarList"><img src="${userInfoData.avatar_url}" data-src="${userInfoData.avatar_url}"/></div>`;
        }
    };
    if (window.location.pathname == `${lang_path}/account/profile/`) {
        //人物头像
        // userInfoData.avatar_url?iD('user_img1').setAttribute('src',userInfoData.avatar_url):null;
        if (userInfoData.email) {
            document.querySelectorAll('.change_info .email').forEach(function (box) {
                box.value = userInfoData.email
            });
        };
        try { iD('plan_bg').classList.remove('active') } catch (e) { };
        //人物名称
        userInfoData.nickname ? iD('user_name').innerHTML = userInfoData.nickname : null;
        userInfoData.nickname ? iD('profile_user_name').innerHTML = userInfoData.nickname : null;
        userInfoData.avatar_url ? iD('profile_user_img').setAttribute('src', userInfoData.avatar_url) : null;
        userInfoData.avatar_url ? iD('left_h1').setAttribute('src', userInfoData.avatar_url) : null;
        //邮箱地址
        userInfoData.email ? iD('profile_user_email').innerHTML = userInfoData.email : null;
        userInfoData.email ? iD('profile_user_email').innerHTML = userInfoData.email : null;
        userInfoData.planname ? iD('profile_plan').innerHTML = userInfoData.planname : null;
        userInfoData.plantitle ? iD('plan_detail').innerHTML = userInfoData.plantitle : iD('plan_detail').innerHTML = 'Premium Monthly';
        userInfoData.planname ? user_plan = userInfoData.planname : user_plan = null;
        if (userInfoData.planname) {
            if (userInfoData.planname.indexOf('Deluxe') > -1) {
                iD('left_corn1').innerHTML = 'Unlimited';
                iD('left_corn2').innerHTML = 'Unlimited';
            } else if (userInfoData.planname.indexOf('Free') > -1) {
                iD('left_corn1').innerHTML = '0';
                iD('left_corn2').innerHTML = '0';
            } else {
                var _num = userInfoData.message_num - userInfoData.usage;
                if (_num <= 0) {
                    _num = 0;
                }
                iD('left_corn1').innerHTML = _num;
                iD('left_corn2').innerHTML = _num;
            }
        } else {

        };
        userInfoData.title_icon ? iD('personal_metal_info').style.backgroundImage = 'url('+userInfoData.title_icon+')' : null;
        userInfoData.title ? iD('personal_metal_info').setAttribute('title',userInfoData.title) : null;
        userInfoData.title && userInfoData.title_icon? iD('personal_metal_info').classList.add('active') : null;
        userInfoData.expire ? iD('plan_expired').innerHTML = userInfoData.expire : null;
        //分享链接
        userInfoData.openid ? iD('share_link').innerHTML = host + 'account/profile/' + userInfoData.openid : iD('share_link').innerHTML = host + 'account/profile/';
        //被人关注数
        userInfoData.fans_num ? iD('profile_followers').innerHTML = autoNumberTransform(userInfoData.fans_num) : null;
        //关注别人数
        userInfoData.follow_num ? iD('profile_following').innerHTML = autoNumberTransform(userInfoData.follow_num) : null;
        userInfoData.interaction ? iD('total_interactions').innerHTML = autoNumberTransform(userInfoData.interaction) : null;
        userInfoData.introduction ? iD('profile_introduction').innerHTML = userInfoData.introduction : iD('profile_introduction').innerHTML = i18n[lang].public_no_Introduction;
        setTimeout(function () {
            try {
                if (window.innerWidth <= 650 && iD('profile_introduction').getBoundingClientRect().height > 48) {
                    iD('profile_introduction').classList.add('show')
                    iD('more_introduction').classList.add('show')
                } else {
                    iD('more_introduction').classList.remove('show')
                    iD('profile_introduction').classList.remove('show')
                }
            } catch (e) { }
        }, 10);
        userInfoData.remaining_num ? iD('bonus_corn').innerHTML = userInfoData.remaining_num : iD('bonus_corn').innerHTML = '0';
        userInfoData.remaining_num ? iD('bonus_corn1').innerHTML = userInfoData.remaining_num : iD('bonus_corn1').innerHTML = '0';
        //剩余聊天数
        if (userInfoData.planname) {
            if (userInfoData.planname.indexOf('Deluxe') > -1) {
                document.querySelectorAll('.total_corn').forEach(function (box) {
                    box.innerHTML = '';
                });
                iD('num_unused').innerHTML = 'Ultimate';
            } else if (userInfoData.planname.indexOf('Free') > -1) {
                document.querySelectorAll('.total_corn').forEach(function (box) {
                    box.innerHTML = '';
                });
                iD('num_unused').innerHTML = '0';
            } else {
                document.querySelectorAll('.total_corn').forEach(function (box) {
                    box.innerHTML = '/' + userInfoData.message_num;
                });
                iD('num_unused').innerHTML = userInfoData.message_num - userInfoData.usage;
            }
        } else {

        }
        if (userInfoData.social_links) {
            for ( var udd in userInfoData.social_links) {
                iD('a_'+udd).classList.remove('active');
                userInfoData.social_links[udd]?iD('a_'+udd).classList.add('active'):null;
                userInfoData.social_links[udd]?iD('a_'+udd).setAttribute('href', userInfoData.social_links[udd]):null;
            }
        };
        try{userInfoData.item_card_num>-1&&userInfoData.item_card_num<10000?iD('remain_unlock').innerHTML=userInfoData.item_card_num:userInfoData.item_card_num>-1&&userInfoData.item_card_num>=10000?iD('remain_unlock').innerHTML='9999+':null;
        userInfoData.item_card_num>-1&&userInfoData.item_card_num<10000?iD('remain_unlock1').innerHTML=userInfoData.item_card_num:userInfoData.item_card_num>-1&&userInfoData.item_card_num>=10000?iD('remain_unlock1').innerHTML='9999+':null;
        }catch(e){};
        if(userInfoData.report_level == 5){
            iD('profile_error').classList.add('active');
            iD('profile_error').setAttribute('attt-id',userInfoData.report_level);
            iD('profile_error_info').innerHTML = 'HeyReal reset your profile and restrited it from display because of inappropriate content.  Please follow the community guideline.'
        }else if(userInfoData.report_level == 4){
            iD('profile_error').classList.add('active');
            iD('profile_error').setAttribute('attt-id',userInfoData.report_level);
            iD('profile_error_info').innerHTML = 'HeyReal reset your profile content because of inappropriate content. Please follow the community guideline.'
        };
    }
}
function scrollToTop(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
        window.scrollTo({
            top: element.offsetTop,
            behavior: 'smooth'
        });
    }
};
//判断大写锁定是否开启
function isCapsLock(e) {
    e = (e) ? e : window.event;

    var charCode = false;
    if (e.which) {
        charCode = e.which;
    } else if (e.keyCode) {
        charCode = e.keyCode;
    }

    var shifton = false;
    if (e.shiftKey) {
        shifton = e.shiftKey;
    } else if (e.modifiers) {
        shifton = !!(e.modifiers & 4);
    }

    if (charCode >= 97 && charCode <= 122 && shifton) {
        return true;
    }

    if (charCode >= 65 && charCode <= 90 && !shifton) {
        return true;
    }

    return false;
}
cLass(".password").onkeypress = function () {
    if (isCapsLock(event)) {
        this.nextElementSibling.innerHTML = i18n[lang].Caps;
    } else {
        this.nextElementSibling.innerHTML = '';
    }
};
//提示未发送验证码？
let no_code_text = '<span>' + i18n[lang].no_code_text + '<span>' + i18n[lang].no_code_text_1 + '</span><span>' + i18n[lang].no_code_text_2 + '</span><span>' + i18n[lang].no_code_text_3 + '<span class="on_feedback">' + i18n[lang].no_code_text_3_span + '</span><span class="attention">' + i18n[lang].no_code_text_4_span + '</span></span></span></span>';
// 超时错误
function overtime(num) {
    _error(i18n[lang].overtime_1 + num + i18n[lang].overtime_2);
};
// 判断是否有网
function isnetwork() {
    if (!navigator.onLine) {
        _error(i18n[lang].isnetwork);
        return false;
    } else {
        return true;
    }
};
var HtmlUtil = {
    /*1.用浏览器内部转换器实现html转码*/
    htmlEncode: function (html) {
        //1.首先动态创建一个容器标签元素，如DIV
        var temp = document.createElement("div");
        //2.然后将要转换的字符串设置为这个元素的innerText(ie支持)或者textContent(火狐，google支持)
        (temp.textContent != undefined) ? (temp.textContent = html) : (temp.innerText = html);
        //3.最后返回这个元素的innerHTML，即得到经过HTML编码转换的字符串了
        var output = temp.innerHTML;
        temp = null;
        return output;
    },
    /*2.用浏览器内部转换器实现html解码*/
    htmlDecode: function (text) {
        //1.首先动态创建一个容器标签元素，如DIV
        var temp = document.createElement("div");
        //2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
        temp.innerHTML = text;
        //3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
        var output = temp.innerText || temp.textContent;
        temp = null;
        return output;
    }
};
//获取地址栏参数
function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) { return pair[1]; }
    }
    return (false);
}
// //点击注册
// cLass ('.third_party_registered_register span').onclick=function(e){
//     e.stopPropagation();
//     third_party_registered_fn(0);
// };
// //绑定google账号
// cLass ('.third_party_registered_btn').onclick=function(e){
//     e.stopPropagation();
//     third_party_registered_fn(21607);
// };